import { mutate } from 'swr'

const mutateURLs = async (urls = []) => {
  for (const url of urls) {
    if (url) await mutate(url)
  }
}

export default mutateURLs
